import { render, staticRenderFns } from "./RegionsIndex.vue?vue&type=template&id=41caf782"
import script from "./RegionsIndex.vue?vue&type=script&lang=js"
export * from "./RegionsIndex.vue?vue&type=script&lang=js"
import style0 from "./RegionsIndex.vue?vue&type=style&index=0&id=41caf782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports